<mat-card fxFlex="100%">
  <form
    [formGroup]="addCartForm"
    (ngSubmit)="onFormSubmit()"
    fxLayout="column"
    fxLayoutAlign="left right"
    fxLayoutGap="10px"
    *ngIf="available"
  >
    <mat-card-content>
      <div fxLayout="row" class="amount">
        <p fxFlex="70%" class="amount-label">
          {{ calcDiscountedPrice | pricify }} {{ 'marketplace.unit_label' |
          translate }}
        </p>
        <img
          (click)="changeValue('dec')"
          src="../../../../assets/img/minus.svg"
          alt="{{'img_alt_text.minus_sign'|translate}}"
        />
        <mat-form-field appearance="outline" fxFlex="20%">
          <input
            matInput
            formControlName="quantity"
            type="number"
            step="1"
            min="1"
            aria-labelledby="units"
            aria-label="{{'purchase.quantity' | translate}}"
          />
        </mat-form-field>
        <img
          (click)="changeValue('inc')"
          src="../../../../assets/img/plus.svg"
          alt="{{'img_alt_text.plus_sign'|translate}}"
        />
        <p id="units" fxFlex="10%" align="right" style="line-height: 33px">
          {{ 'add_cart.units' | translate }}
        </p>
      </div>
      <div
        *ngIf="
          product.available && addCartForm.value.quantity > available.limit
        "
      >
        <p class="error">
          {{ 'add_cart.error.over_limit_quantity' | translate }}
        </p>
      </div>
      <div
        *ngIf="
          product.available &&
          addCartForm.value.quantity <= available.limit &&
          addCartForm.value.quantity > available.availability
        "
      >
        <p class="error">
          {{ 'add_cart.error.over_available_quantity' | translate }}
        </p>
      </div>
      <div *ngIf="!product.available">
        <p class="error">{{ 'add_cart.error.not_available' | translate }}</p>
      </div>
      <app-advantage
        *ngIf="calcDiscount"
        [lixDiscountedPrice]="calcDiscountedPrice * product.quantity"
        [totalDiscount]="calcDiscount * product.quantity"
        [price]="price"
        [priceText]="priceText"
        [discountedPriceText]="discountedPriceText"
      >
      </app-advantage>
      <mat-divider
        [inset]="true"
        *ngIf="product.vendor_price || calcDiscount"
      ></mat-divider>
      <div fxLayout="row">
        <p fxFlex="50%" class="total-label">
          {{ 'add_cart.total' | translate }}:
        </p>
        <p fxFlex="50%" class="total-amount" align="right">
          {{ calcDiscountedPrice * product.quantity | pricify }}
        </p>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button
        mat-raised-button
        fxFlex="100%"
        class="global-btn-blue large-font"
        type="submit"
        [disabled]="
          addCartForm.value.quantity > available.availability ||
          !addCartForm.valid ||
          !product.available
        "
      >
        <span *ngIf="!added">
          + {{ 'marketplace.add_button' | translate }}
        </span>
        <span *ngIf="added">
          <mat-icon>check</mat-icon>
        </span>
      </button>
    </mat-card-actions>
  </form>
</mat-card>
